import { memo } from "react";
import BassTriadDiagram from "@/components/music/BassTriadDiagram";
import GuitarChordDiagram from "@/components/music/GuitarChordDiagram";
import PianoChordVisualizer from "@/components/music/PianoChordVisualizer";

const InstrumentChordVisualizer = memo(
  ({ instrumentMode, chord, activeNotes, nextChord, timeToNextChord, compact, showLabels, capo = 0, bassRootOnly = false, variant = "dark" }) => {
    if (instrumentMode === "bass") {
      return <BassTriadDiagram chordName={chord} compact={compact} rootOnly={bassRootOnly} variant={variant} />;
    }
    if (instrumentMode === "guitar") {
      return <GuitarChordDiagram chordName={chord} capo={capo} compact={compact} variant={variant} />;
    }
    return (
      <PianoChordVisualizer
        chord={chord}
        activeNotes={activeNotes}
        nextChord={nextChord}
        timeToNextChord={timeToNextChord}
        compact={compact}
        showLabels={showLabels}
        instrumentMode="piano"
        variant={variant}
      />
    );
  }
);

InstrumentChordVisualizer.displayName = "InstrumentChordVisualizer";

export default InstrumentChordVisualizer;
